<script setup lang="ts">
const route = useRoute();

// 公開用URL
const dir_name = computed(() => route.params.dir_name ?? "");
//　プレビュー用
const page_cd = computed(() => route.query.page_cd ?? "");
const mode = computed(() => route.query.mode ?? "");

const { data } = await useFetch<{
  body: string;
  title: string;
  description: string;
}>(
  () =>
    `/api/content?content_name=${dir_name.value}&mode=${mode.value}&page_cd=${page_cd.value}`,
);
if (data.value && !data.value.body) {
  throw createError({ statusCode: 404, message: "Not Found", fatal: true });
}

if (data.value) {
  useHead({
    title: data.value.title,
    meta: [{ name: "description", content: data.value.description }],
  });
}

// パンくず
useBreadcrumbs([
  { name: "TOP", path: "/" },
  {
    name: `${data.value?.title}`,
    path: `/contents.php/${route.params.dir_name}`,
  },
]);
</script>

<template>
  <div>
    <!-- alert -->
    <p
      v-if="data && mode == 'preview'"
      class="text-red-500 text-2xl border p-5 border-red-500"
    >
      このURLは、プレビュー中です。 リンク設定しないようご注意ください。
    </p>
    <div class="p-staticpage wrapper mb-8" v-if="data" v-html="data.body"></div>
  </div>
</template>
